import script from "./pack-history.vue?vue&type=script&setup=true&lang=js"
export * from "./pack-history.vue?vue&type=script&setup=true&lang=js"

import "./pack-history.vue?vue&type=style&index=0&id=4d365e61&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./pack-history.vue?vue&type=style&index=1&id=4d365e61&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d365e61"]])

export default __exports__